import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar, Container } from 'react-bootstrap';
import axios from 'axios';
import logo from '../../assets/logo.png';

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    activeProducts: 0,
    categories: 0,
    deletedProducts: 0
  });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/admin/stats`);
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('adminAuth');
    navigate('/');
  };

  return (
    <>
      {/* Main Navigation */}
      <Navbar 
        expand="lg" 
        className="animated-nav-background"
        style={{ 
          boxShadow: '0 2px 10px rgba(232, 12, 129, 0.2)',
          padding: '1rem 0',
          backdropFilter: 'blur(10px)',
          borderBottom: '1px solid rgba(232, 12, 129, 0.1)'
        }}
        variant="dark"
      >
        <Container>
          <Navbar.Brand href="/">
            <img 
              src={logo} 
              alt="Star Tidbits" 
              style={{ 
                height: '60px', 
                width: 'auto',
                maxWidth: '100%'
              }}
            />
          </Navbar.Brand>
          <div style={{ display: 'flex', alignItems: 'center', gap: '2rem', marginLeft: 'auto' }}>
            <h3 style={{ color: 'white', margin: 0, fontSize: '1.25rem' }}>Admin Dashboard</h3>
            <button 
              onClick={() => navigate('/admin/products')}
              className="btn btn-outline"
              style={{ color: 'white', borderColor: 'white', fontSize: '0.875rem' }}
            >
              Products
            </button>
            <button 
              onClick={() => navigate('/admin/messages')}
              className="btn btn-outline"
              style={{ color: 'white', borderColor: 'white', fontSize: '0.875rem' }}
            >
              Messages
            </button>
            <button 
              onClick={handleLogout}
              className="btn btn-outline"
              style={{ color: 'white', borderColor: 'white', fontSize: '0.875rem' }}
            >
              Logout
            </button>
          </div>
        </Container>
      </Navbar>
      
      <div style={{ padding: '2rem 0', minHeight: 'calc(100vh - 80px)', backgroundColor: 'var(--neutral-light)' }}>
        <div className="container">

        {/* Dashboard Cards */}
        <div className="grid grid-3" style={{ marginBottom: '2rem' }}>
          <div 
            className="card" 
            style={{ cursor: 'pointer', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
            onClick={() => navigate('/admin/products')}
          >
            <div>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📦</div>
              <h3>Product Management</h3>
              <p>Add, edit, and manage product catalog</p>
            </div>
            <button className="btn btn-primary" style={{ marginTop: 'auto' }}>
              Manage Products
            </button>
          </div>

          <div 
            className="card" 
            style={{ cursor: 'pointer', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
            onClick={() => navigate('/admin/messages')}
          >
            <div>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>💬</div>
              <h3>Messages</h3>
              <p>View and respond to customer inquiries</p>
            </div>
            <button className="btn btn-primary" style={{ marginTop: 'auto' }}>
              View Messages
            </button>
          </div>

          <div className="card" style={{ textAlign: 'center', opacity: 0.6, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📊</div>
              <h3>Analytics</h3>
              <p>View sales reports and statistics</p>
            </div>
            <button className="btn btn-secondary" disabled style={{ marginTop: 'auto' }}>
              Coming Soon
            </button>
          </div>
        </div>

        {/* Quick Stats */}
        <div className="card">
          <h3>Quick Overview</h3>
          <div className="grid grid-3" style={{ marginTop: '1rem' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '2rem', fontWeight: '700', color: 'var(--primary-saffron)' }}>
                {loading ? '--' : stats.activeProducts}
              </div>
              <div style={{ fontSize: '0.875rem', opacity: 0.7 }}>Active Products</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '2rem', fontWeight: '700', color: 'var(--accent-green)' }}>
                {loading ? '--' : stats.categories}
              </div>
              <div style={{ fontSize: '0.875rem', opacity: 0.7 }}>Categories</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '2rem', fontWeight: '700', color: 'var(--soft-gold)' }}>
                {loading ? '--' : stats.deletedProducts}
              </div>
              <div style={{ fontSize: '0.875rem', opacity: 0.7 }}>Deleted Products</div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;